import { useLvgState } from 'hooks/games/lvg/useLvgState'
import { LvgAssetHeader } from './LvgAssetHeader'

export const LvgYoloGameHeader = () => {
  const { activeAsset, setActiveAsset } = useLvgState()

  return <LvgAssetHeader assetInfo={activeAsset} onSelect={setActiveAsset} />
}
